import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-83f9a7c8")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("audio", {
    controls: "",
    src: _ctx.url
  }, [
    _createVNode("div", null, _toDisplayString(_ctx.$t("common.error.audio.support")), 1)
  ], 8, ["src"]))
})